// Cloudinary delivery URL for the seller's EU legal guarantee notice: f_auto serves
// WebP/AVIF where the browser supports it and q_auto:good keeps small print and the QR code
// sharp while cutting the bytes (and so the Cloudinary bandwidth used). The stored URL stays
// the untouched original, which the "open full size" link keeps using.
export const optimizedNoticeUrl = url =>
  typeof url === 'string' && url.includes('res.cloudinary.com') && url.includes('/upload/')
    ? url.replace('/upload/', '/upload/f_auto,q_auto:good/')
    : url;
